/* ============================================================
   Verdé storefront — interactions (native Shopify AJAX cart)
   ============================================================ */
(function () {
  'use strict';

  var PROMO_CODE = (window.VerdeSettings && window.VerdeSettings.promoCode) || 'FRESH10';
  var PROMO_PCT = (window.VerdeSettings && window.VerdeSettings.promoPct) || 10;
  var PROMO_MIN = (window.VerdeSettings && window.VerdeSettings.promoMin) || 50; // dollars
  var moneyFmt = (window.VerdeSettings && window.VerdeSettings.moneyFormat) || '${{amount}}';

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    value = parts.join('.');
    return moneyFmt.replace('{{amount}}', value).replace('{{ amount }}', value);
  }

  var promoApplied = false;

  /* ---------- scroll reveal ---------- */
  function setupReveal() {
    var rows = $all('.reveal-row:not(.in-view)');
    if (!rows.length) return;
    if (!('IntersectionObserver' in window)) { rows.forEach(function (r) { r.classList.add('in-view'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); } });
    }, { threshold: 0.18 });
    rows.forEach(function (r) { io.observe(r); });
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#v-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'v-toast';
      t.style.cssText = 'position:fixed;bottom:28px;left:50%;transform:translateX(-50%);z-index:80;background:#2c2a26;color:#fdfdfb;font-size:14px;letter-spacing:0.03em;padding:14px 26px;border-radius:999px;box-shadow:0 12px 30px rgba(28,32,26,0.35);animation:fadeIn 0.25s ease;';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.display = 'block';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.style.display = 'none'; }, 2200);
  }

  /* ---------- cart drawer ---------- */
  function openCart() { var d = $('#cart-root'); if (d) { d.style.display = 'block'; document.body.style.overflow = 'hidden'; refreshCart(); } }
  function closeCart() { var d = $('#cart-root'); if (d) { d.style.display = 'none'; document.body.style.overflow = ''; } }

  function setCartCount(n) {
    $all('.js-cart-count').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  function renderCart(cart) {
    setCartCount(cart.item_count);
    var emptyEl = $('#cart-empty'), listWrap = $('#cart-hasitems');
    if (!listWrap) return;
    if (cart.item_count === 0) {
      if (emptyEl) emptyEl.style.display = 'flex';
      listWrap.style.display = 'none';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    listWrap.style.display = 'flex';

    var itemsHtml = cart.items.map(function (it) {
      var imgUrl = it.image
        || (it.featured_image && it.featured_image.url)
        || (window.VerdeProductImages && window.VerdeProductImages[it.handle])
        || '';
      return '' +
        '<div style="display:flex;gap:14px;padding:20px 0;border-bottom:1px solid rgba(95,122,76,0.1);">' +
          '<div class="cart-thumb">' +
            (imgUrl ? '<img src="' + imgUrl + '" alt="' + escapeHtml(it.product_title) + '">' : '') +
          '</div>' +
          '<div style="flex:1;">' +
            '<h3 style="margin:0 0 4px;font-size:14px;font-weight:400;color:#2c2a26;line-height:1.3;">' + escapeHtml(it.product_title) + '</h3>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<p style="margin:0 0 6px;font-size:12px;color:#9a9a92;">' + escapeHtml(it.variant_title) + '</p>' : '') +
            '<p style="margin:0 0 8px;font-size:13px;font-weight:400;color:#5f7a4c;">' + formatMoney(it.price) + '</p>' +
            '<div style="display:flex;align-items:center;gap:12px;">' +
              '<div style="display:inline-flex;align-items:center;border:1px solid rgba(95,122,76,0.3);border-radius:999px;">' +
                '<button class="js-qty" data-key="' + it.key + '" data-delta="-1" style="border:none;background:transparent;width:28px;height:28px;font-size:16px;color:#5f7a4c;cursor:pointer;">−</button>' +
                '<span style="min-width:22px;text-align:center;font-size:14px;color:#2c2a26;">' + it.quantity + '</span>' +
                '<button class="js-qty" data-key="' + it.key + '" data-delta="1" style="border:none;background:transparent;width:28px;height:28px;font-size:16px;color:#5f7a4c;cursor:pointer;">+</button>' +
              '</div>' +
              '<button class="js-remove" data-key="' + it.key + '" style="border:none;background:transparent;font-size:12px;letter-spacing:0.04em;color:#a3a39b;cursor:pointer;padding:0;">Remove</button>' +
            '</div>' +
          '</div>' +
          '<span style="font-size:15px;font-weight:500;color:#2c2a26;">' + formatMoney(it.final_line_price) + '</span>' +
        '</div>';
    }).join('');
    $('#cart-items').innerHTML = itemsHtml;

    var subtotal = cart.items_subtotal_price; // cents
    var valid = promoApplied && (subtotal / 100) > PROMO_MIN;
    var discount = valid ? Math.round(subtotal * (PROMO_PCT / 100)) : 0;
    $('#cart-subtotal').textContent = formatMoney(subtotal);
    var discRow = $('#cart-discount-row');
    if (valid) {
      discRow.style.display = 'flex';
      $('#cart-discount').textContent = '−' + formatMoney(discount);
    } else {
      discRow.style.display = 'none';
    }
    var total = subtotal - discount;
    $('#cart-total').textContent = formatMoney(total);
    $('#cart-checkout-total').textContent = formatMoney(total);
  }

  function escapeHtml(s) { return (s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        var title = data.product_title || data.title || (data.items && data.items[0] && data.items[0].product_title) || 'item';
        return refreshCart().then(function () {
          toast('Added to cart — ' + title);
          openCart();
        });
      })
      .catch(function () { toast('Could not add to cart.'); });
  }

  function changeQty(key, delta) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = null;
      for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].key === key) { line = cart.items[i]; break; } }
      if (!line) return;
      var newQty = Math.max(0, line.quantity + delta);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });
  }

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function applyPromo() {
    var input = $('#promo-input');
    var msg = $('#promo-msg');
    var code = (input.value || '').trim().toUpperCase();
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var sub = cart.items_subtotal_price / 100;
      if (code !== PROMO_CODE) { promoApplied = false; showPromoMsg("That code isn't valid.", false); renderCart(cart); return; }
      if (sub <= PROMO_MIN) {
        promoApplied = false;
        var need = (PROMO_MIN + 0.01 - sub); if (need < 0) need = 0.01;
        showPromoMsg(PROMO_CODE + ' applies to orders over $' + PROMO_MIN + '. Add $' + need.toFixed(2) + ' more to qualify.', false);
        renderCart(cart); return;
      }
      promoApplied = true;
      showPromoMsg(PROMO_CODE + ' applied — ' + PROMO_PCT + '% off!', true);
      renderCart(cart);
    });
  }
  function showPromoMsg(text, ok) {
    var msg = $('#promo-msg');
    if (!msg) return;
    msg.textContent = text;
    msg.style.color = ok ? '#5f7a4c' : '#b06a4c';
    msg.style.display = 'block';
  }

  function checkout() {
    if (promoApplied) {
      window.location.href = '/discount/' + encodeURIComponent(PROMO_CODE) + '?redirect=/checkout';
    } else {
      window.location.href = '/checkout';
    }
  }

  /* ---------- coupon modal ---------- */
  function initCoupon() {
    var modal = $('#coupon-modal'), tab = $('#coupon-tab');
    if (!modal || !tab) return;
    var seen = false;
    try { seen = sessionStorage.getItem('verdeCoupon') === '1'; } catch (e) {}
    if (seen) { modal.style.display = 'none'; tab.style.display = 'block'; }
    else { modal.style.display = 'flex'; tab.style.display = 'none'; }

    function minimize() { modal.style.display = 'none'; tab.style.display = 'block'; try { sessionStorage.setItem('verdeCoupon', '1'); } catch (e) {} }
    $all('.js-coupon-close', modal).forEach(function (b) { b.addEventListener('click', minimize); });
    modal.addEventListener('click', function (e) { if (e.target === modal) minimize(); });
    tab.addEventListener('click', function () { modal.style.display = 'flex'; tab.style.display = 'none'; });
    var copyBtn = $('#coupon-copy');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      try { navigator.clipboard.writeText(PROMO_CODE); } catch (e) {}
      copyBtn.textContent = 'Copied!';
      setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1800);
    });
  }

  /* ---------- product detail (variant + qty) ---------- */
  function initProductDetail() {
    var root = $('#product-detail');
    if (!root) return;
    var variants = JSON.parse(root.getAttribute('data-variants') || '[]');
    var selected = variants[0];
    var qty = 1;
    var priceEl = $('#pd-price'), qtyEl = $('#pd-qty'), addBtn = $('#pd-add'), addLabel = $('#pd-add-label');

    function render() {
      if (priceEl) priceEl.textContent = formatMoney(selected.price * qty);
      if (qtyEl) qtyEl.textContent = qty;
      if (addLabel) addLabel.textContent = formatMoney(selected.price * qty);
      $all('.js-variant').forEach(function (b) {
        var on = parseInt(b.getAttribute('data-vid'), 10) === selected.id;
        b.style.background = on ? '#ffffff' : 'transparent';
        b.style.color = on ? '#2c2a26' : '#6f6f68';
        b.style.boxShadow = on ? '0 2px 6px rgba(44,42,38,0.12)' : 'none';
      });
    }
    $all('.js-variant').forEach(function (b) {
      b.addEventListener('click', function () {
        var vid = parseInt(b.getAttribute('data-vid'), 10);
        for (var i = 0; i < variants.length; i++) { if (variants[i].id === vid) { selected = variants[i]; break; } }
        render();
      });
    });
    var dec = $('#pd-dec'), inc = $('#pd-inc');
    if (dec) dec.addEventListener('click', function () { qty = Math.max(1, qty - 1); render(); });
    if (inc) inc.addEventListener('click', function () { qty += 1; render(); });
    if (addBtn) addBtn.addEventListener('click', function () { addToCart(selected.id, qty); });
    render();
  }

  /* ---------- global delegated events ---------- */
  function initEvents() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-action]') : null;
      if (!t) {
        // qty / remove inside drawer
        var q = e.target.closest && e.target.closest('.js-qty');
        if (q) { changeQty(q.getAttribute('data-key'), parseInt(q.getAttribute('data-delta'), 10)); return; }
        var rm = e.target.closest && e.target.closest('.js-remove');
        if (rm) { removeItem(rm.getAttribute('data-key')); return; }
        var add = e.target.closest && e.target.closest('.js-add');
        if (add) { e.preventDefault(); addToCart(parseInt(add.getAttribute('data-variant-id'), 10), parseInt(add.getAttribute('data-qty') || '1', 10)); return; }
        return;
      }
      var action = t.getAttribute('data-action');
      if (action === 'open-cart') { e.preventDefault(); openCart(); }
      else if (action === 'close-cart') { closeCart(); }
      else if (action === 'apply-promo') { applyPromo(); }
      else if (action === 'checkout') { checkout(); }
      else if (action === 'cart-shop') { closeCart(); window.location.href = '/collections/shop'; }
    });
  }

  /* ---------- hero background video (force silent inline autoplay) ---------- */
  function initHeroVideo() {
    var v = $('.hero-video');
    if (!v) return;
    v.muted = true; v.defaultMuted = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    tryPlay();
    // some mobile browsers only allow play after first interaction/visibility
    document.addEventListener('touchstart', tryPlay, { once: true, passive: true });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tryPlay(); });
  }

  /* ---------- PDP gallery ---------- */
  function initGallery() {
    var allThumbs = $all('.pdp-thumb'); if (!allThumbs.length) return;
    var mainImgWrap = $('#pdp-main-img'), mainImg = mainImgWrap && mainImgWrap.querySelector('img');
    var vid = $('#pdp-main-video');
    function setActive(t) { allThumbs.forEach(function (x) { x.classList.remove('is-active'); }); t.classList.add('is-active'); }
    $all('.js-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (mainImg && full) mainImg.src = full;
        if (mainImgWrap) mainImgWrap.style.display = '';
        if (vid) { vid.pause(); vid.style.display = 'none'; }
        setActive(t);
      });
    });
    var vthumb = $('.js-thumb-video');
    if (vthumb && vid) {
      vthumb.addEventListener('click', function () {
        vid.style.display = 'block';
        if (mainImgWrap) mainImgWrap.style.display = 'none';
        var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
        setActive(vthumb);
      });
    }
  }

  /* ---------- sticky mini add-to-cart ---------- */
  function initStickyBuy() {
    var bar = $('#pdp-sticky'), addMain = $('#pd-add');
    if (!bar || !addMain || !('IntersectionObserver' in window)) return;
    var stickyAdd = $('#pdp-sticky-add'), stickyPrice = $('#pdp-sticky-price'), pdPrice = $('#pd-price');
    function sync() { if (stickyPrice && pdPrice) stickyPrice.textContent = pdPrice.textContent; }
    if (stickyAdd) stickyAdd.addEventListener('click', function () { addMain.click(); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.top < 0) { bar.classList.add('is-shown'); sync(); }
        else { bar.classList.remove('is-shown'); }
      });
    }, { threshold: 0 });
    io.observe(addMain);
    document.addEventListener('click', function () { setTimeout(sync, 70); });
  }

  /* ---------- nav mega-menu + floating 3D preview (desktop only) ---------- */
  function initMegaMenu() {
    var trigger = $('#nav-shop-trigger'), mega = $('#nav-mega');
    if (!trigger || !mega) return;
    if (window.matchMedia && window.matchMedia('(max-width: 900px)').matches) return;
    var stage = $('#nav-preview'), pimg = $('#nav-preview-img'), pvid = $('#nav-preview-video'), t;
    function open() { clearTimeout(t); mega.classList.add('is-open'); }
    function close() { t = setTimeout(function () { mega.classList.remove('is-open'); if (stage) stage.classList.remove('is-visible'); if (pvid) pvid.pause(); }, 180); }
    [trigger, mega].forEach(function (el) { el.addEventListener('mouseenter', open); el.addEventListener('mouseleave', close); });
    $all('.nav-mega-link', mega).forEach(function (l) {
      var src = l.getAttribute('data-preview'), vsrc = l.getAttribute('data-video');
      l.addEventListener('mouseenter', function () {
        if (!stage) return;
        if (vsrc && pvid) {
          if (pvid.getAttribute('src') !== vsrc) pvid.setAttribute('src', vsrc);
          pvid.style.display = 'block'; if (pimg) pimg.style.display = 'none';
          stage.classList.add('has-video'); stage.classList.add('is-visible');
          var pr = pvid.play(); if (pr && pr.catch) pr.catch(function () {});
        } else if (src && pimg) {
          pimg.src = src; pimg.style.display = 'block';
          if (pvid) { pvid.pause(); pvid.style.display = 'none'; }
          stage.classList.remove('has-video'); stage.classList.add('is-visible');
        }
      });
    });
  }

  /* ---------- recently viewed (localStorage) ---------- */
  function initRecentlyViewed() {
    var KEY = 'verdeRecent', list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    var cur = window.VerdeCurrentProduct;
    if (cur && cur.handle) {
      list = list.filter(function (p) { return p.handle !== cur.handle; });
      list.unshift(cur); list = list.slice(0, 8);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    var wrap = $('#recently-viewed'); if (!wrap) return;
    var show = list.filter(function (p) { return !cur || p.handle !== cur.handle; }).slice(0, 4);
    if (show.length < 2) { wrap.style.display = 'none'; return; }
    wrap.innerHTML = '<div class="recent-wrap"><div class="recent-head"><p style="margin:0 0 8px;font-size:12px;letter-spacing:0.3em;text-transform:uppercase;color:#8a9d8e;">Continue exploring</p><h2 style="margin:0;font-size:26px;font-weight:300;color:#2c2a26;">Recently viewed</h2></div><div class="recent-grid">' +
      show.map(function (p) {
        return '<a class="recent-card" href="' + p.url + '"><div class="rc-img">' + (p.img ? '<img src="' + p.img + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy">' : '') + '</div><div class="rc-b"><p class="rc-n">' + escapeHtml(p.title || '') + '</p><span class="rc-p">' + escapeHtml(p.price || '') + '</span></div></a>';
      }).join('') + '</div></div>';
    wrap.style.display = 'block';
  }

  function boot() {
    setupReveal();
    initCoupon();
    initHeroVideo();
    initProductDetail();
    initGallery();
    initStickyBuy();
    initMegaMenu();
    initRecentlyViewed();
    initEvents();
    /* cart count is server-rendered in the header, so no /cart.js fetch is
       needed on load — the drawer fetches fresh contents when it opens. */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
